import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import hasFeature from 'modules/core/lib/hasFeature'

import { planToUpgrade as getPlanToUpgrade } from 'modules/billing/lib/utils'
import type { Families } from 'modules/billing/store/models/Plan'

const DEFAULT_RETURN = {
  isOverlimit: false,
  currentSeats: 0,
  limitEmployeesCurrentPlan: 0,
  planToUpgrade: null,
}

interface ReturnType {
  isOverlimit: boolean
  currentSeats: number
  limitEmployeesCurrentPlan: number
  planToUpgrade: Families | null | undefined
}

const useOverlimitEmployeesChecker = (): ReturnType => {
  const {
    company: { subscription },
    canManageSubscription,
  } = useCurrentSession()

  const currentSeats = subscription.seatCount ?? 0
  const isOverlimit =
    hasFeature('enforce_employees_limits') && subscription.employeesLimit <= currentSeats
  const planToUpgradeName = getPlanToUpgrade(subscription.planFamily)

  return useUnsafeMemo<ReturnType>(() => {
    if (!canManageSubscription || subscription.inFreeTrial) return DEFAULT_RETURN

    return {
      isOverlimit,
      currentSeats,
      planToUpgrade: planToUpgradeName,
      limitEmployeesCurrentPlan: subscription.employeesLimit,
    }
  }, [subscription, canManageSubscription, currentSeats, isOverlimit, planToUpgradeName])
}

export default useOverlimitEmployeesChecker
